import { RowWithDate } from '../types';
import { calculateDivision, sortDataByQuarter } from './helpers';

export const filterPortCoData = (data: RowWithDate[]) => {
  const defaultQuarter = data[0].COMPASS_DEFAULT_QUARTER;
  const sortedData = sortDataByQuarter([...data]).reverse();

  const defaultQuarterIdx =
    !defaultQuarter ||
    sortedData.findIndex(d => d.QUARTER === defaultQuarter) === -1
      ? 0
      : sortedData.findIndex(d => d.QUARTER === defaultQuarter);

  const getCurrentArr = (arrRange: string): number => {
    switch (arrRange) {
      case '<$25M':
        return 24000000;
      case '$25-$50M':
        return 30000000;
      case '$50-$100M':
        return 75000000;
      case '$100-$200M':
        return 150000000;
      case '>$200M':
        return 300000000;
    }

    return 0;
  };

  const filteredData = sortedData
    .slice(defaultQuarterIdx, defaultQuarterIdx + 4)
    .map((d: RowWithDate, index: number) => ({
      label: d.QUARTER,
      requiredInfo: {
        currentARR: getCurrentArr(String(d.ARR_RANGE)),
        revenue: d.REVENUE_TOTAL as number,
        fcfMargin: (d.MARGIN_FCF as number) * 100,
        avgDealSize: d.AVG_CONTRACT_VALUE as number,
        totalHeadcount: d.EMPLOYEES_TOTAL as number,
        grossMargin: (d.MARGIN_GROSSPROFIT as number) * 100,
        yoyARR:
          Number(sortedData?.[index + 4]?.['ARR_EOP']) === 0
            ? null
            : calculateDivision(
                Number(d.ARR_EOP),
                (sortedData?.[index + 4]?.['ARR_EOP'] as number) || 0,
                false,
                true
              )! * 100,
        arrPerFTE: d.ARR_PER_FTE as number,
        ruleOf40: (d.RULE_OF_40 as number) * 100
      },
      growthAndRetention: {
        newLogoArrOfGrossNew:
          (d.ARR_PERCTOTAL_GROSSNEW_NEWLOGO as number) * 100,
        expansionArrOfGrossNew:
          (d.ARR_PERCTOTAL_GROSSNEW_EXPANSION as number) * 100,
        quickRatio: d.QUICK_RATIO_ARR as number,
        netDollarRetention: (d.RETENTION_NET_ARR_ANNUALIZED as number) * 100,
        grossDollarRetention:
          (d.RETENTION_GROSS_ARR_ANNUALIZED as number) * 100,
        newLogoVelocity: (d.NEW_LOGO_VELOCITY as number) * 100,
        newLogoArr: d.ARR_NEWLOGO as number,
        expansionArr: d.ARR_EXPANSION as number
      },
      operationalEfficiency: {
        burnMultiple: d.BURN_MULTIPLE as number,
        netMagicNumber: d.MAGICNUMBER_NET as number,
        rD: d.OPEX_RD as number,
        gA: d.OPEX_GA as number,
        sM: d.OPEX_SM as number,
        cacPaybackPeriod: d.CAC_PAYBACK as number,
        rdPercent: (d.MARGIN_OPEX_RD as number) * 100,
        gaPercent: (d.MARGIN_OPEX_GA as number) * 100,
        smPercent: (d.MARGIN_OPEX_SM as number) * 100,
        totalOpex: d.OPEX_TOTAL as number
      },
      headCount: {
        opexPerFTE: d.OPEX_PER_FTE as number,
        rDHead: d.EMPLOYEES_RD as number,
        gAHead: d.EMPLOYEES_GA as number,
        sMHead: d.EMPLOYEES_SM as number,
        otherHead: d.EMPLOYEES_OTHER as number,
        rDHeadPercent: (d.EMPLOYEES_PERCTOTAL_RD as number) * 100,
        gAHeadPercent: (d.EMPLOYEES_PERCTOTAL_GA as number) * 100,
        sMHeadPercent: (d.EMPLOYEES_PERCTOTAL_SM as number) * 100,
        otherHeadPercent: (d.EMPLOYEES_PERCTOTAL_OTHER as number) * 100
      }
    }));

  filteredData.push({
    label: '',
    growthAndRetention: {
      expansionArr: 0,
      expansionArrOfGrossNew: 0,
      grossDollarRetention: 0,
      netDollarRetention: 0,
      newLogoArr: 0,
      newLogoArrOfGrossNew: 0,
      newLogoVelocity: 0,
      quickRatio: 0
    },
    headCount: {
      gAHead: 0,
      gAHeadPercent: 0,
      opexPerFTE: 0,
      rDHead: 0,
      rDHeadPercent: 0,
      sMHead: 0,
      sMHeadPercent: 0,
      otherHead: 0,
      otherHeadPercent: 0
    },
    operationalEfficiency: {
      burnMultiple: 0,
      cacPaybackPeriod: 0,
      gA: 0,
      gaPercent: 0,
      netMagicNumber: 0,
      rD: 0,
      rdPercent: 0,
      sM: 0,
      smPercent: 0,
      totalOpex: 0
    },
    requiredInfo: {
      arrPerFTE: 0,
      avgDealSize: 0,
      currentARR: 0,
      fcfMargin: 0,
      grossMargin: 0,
      revenue: 0,
      ruleOf40: 0,
      totalHeadcount: 0,
      yoyARR: 0
    }
  });

  return {
    filteredData,
    defaultQuarterIdx:
      !defaultQuarter ||
      sortedData.findIndex(d => d.QUARTER === defaultQuarter) === -1
        ? 4
        : 0
  };
};
